import { ReactNode } from 'react'
import { useNetworkStatus } from '../../utils/useNetworkStatus'
import NoInternetScreen from '../../features/ui/NoInternetScreen'

interface NetworkGuardProps {
  children: ReactNode
  showNoInternetOnOffline?: boolean
}

/**
 * Component to guard against network connectivity issues
 * Shows NoInternetScreen when device is offline
 */
export default function NetworkGuard({ 
  children, 
  showNoInternetOnOffline = true 
}: NetworkGuardProps) {
  const { isOnline } = useNetworkStatus()

  // If offline and we should show no internet screen
  if (!isOnline && showNoInternetOnOffline) {
    return <NoInternetScreen />
  }

  // If online or we don't want to show no internet screen, render children
  return <>{children}</>
}
